module.exports = __webpack_public_path__ + "static/media/sell-from-home.9d50b11c.png";